import { render, staticRenderFns } from "./SimplesLayout.vue?vue&type=template&id=e20f0146&scoped=true&lang=pug&"
import script from "./SimplesLayout.vue?vue&type=script&lang=ts&"
export * from "./SimplesLayout.vue?vue&type=script&lang=ts&"
import style0 from "./SimplesLayout.vue?vue&type=style&index=0&id=e20f0146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20f0146",
  null
  
)

export default component.exports